package com.ives.utils;

import js.Browser;

class FullScreenUtils{
	public static var isFullscreen:Bool = false;

	private static function onChange(event){
		isFullscreen = !isFullscreen;
	}

	public static function enterFullSreen(selector:String = "body"){
		#if js
		untyped __js__('var docelem = document.querySelector("#mainComponent");
			if (docelem.requestFullscreen) {
				docelem.requestFullscreen();
			}
			else if (docelem.mozRequestFullScreen) {
				docelem.mozRequestFullScreen();
			}
			else if (docelem.webkitRequestFullScreen) {
				docelem.webkitRequestFullScreen();
			}
			else if (docelem.msRequestFullscreen) {
				docelem.msRequestFullscreen();
			}');
		#end
	}

	public static function fullSreenSupported():Bool{
		var supported:Bool = false;

		#if js
		untyped __js__('var docelem = document.querySelector("#mainComponent");
			if (docelem.requestFullscreen) {
				supported = true;
			}
			else if (docelem.mozRequestFullScreen) {
				supported = true;
			}
			else if (docelem.webkitRequestFullScreen) {
				supported = true;
			}
			else if (docelem.msRequestFullscreen) {
				supported = true;
			}');
		#end

		return supported;
	}

	public static function exitFullSreen(){
		#if js
		untyped __js__('if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
		}');
		#end
	}
}
